import React from 'react';
import inapAgenda from "../src/imgs/page_headers/principal.png";

export const RegionalBannerCentral = () => {
  const url = "https://inap.gob.gt/web/wp-content/uploads/2021/11/AGENDA-DE-SERVICIOS-PARA-EL-FORTALECIMIENTO-INSTITUCIONAL-2025.pdf";

  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <div className="regional-head-area">
        <div className="regional-title">
          <div className="regional-block-title"></div>
          <h3>Servicios para el fortalecimiento institucional</h3>
        </div>
      </div>
      <style>{`
        .regional-head-area {
          background-image: url(${inapAgenda});
          background-size: cover;
          background-position: center top;
          background-repeat: no-repeat;
          width: 100%;
          position: relative;
          background-color: #f5f5f5;
        }

       
        @media (max-width: 549px) {
          .regional-head-area {
            height: 90px;
            background-size: contain;
          }
          .regional-title h3 {
            font-size: 16px;
          }
        }

        @media (min-width: 550px) and (max-width: 767px) {
          .regional-head-area {
            height: 130px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 18px;
          }
        }

        @media (min-width: 768px) and (max-width: 991px) {
          .regional-head-area {
            height: 170px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 20px;
          }
        }

        @media (min-width: 992px) and (max-width: 1199px) {
          .regional-head-area {
            height: 215px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 22px;
          }
        }

        @media (min-width: 1200px) and (max-width: 1990px) {
          .regional-head-area {
            height: 250px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 24px;
          }
        }

        @media (min-width: 1491px) {
          .regional-head-area {
            height: 260px;
            width: 100%;
          }
          .regional-title h3 {
            font-size: 26px;
          }
        }
      `}</style>
    </a>
  );
};